import { Component, Input } from '@angular/core';
import { ShipmentOrderSpec } from '@core/models/job-file/shipment-order-spec.model';

@Component({
  selector: 'hmt-job-plan-window-cards',
  templateUrl: './job-plan-window-cards.component.html',
  styleUrls: ['./job-plan-window-cards.component.scss'],
  standalone: false
})
export class JobPlanWindowCardsComponent {
  @Input() order!: ShipmentOrderSpec;

  formatWindowDateTime(order: ShipmentOrderSpec, isPickup: boolean): string {
    try {
      let startDate: Date;
      let endDate: Date;

      if (isPickup) {
        if (!order.pickupTime) {
          return '';
        }
        startDate = new Date(order.pickupTime);
        endDate = new Date(startDate);
        // Add time window hours to get end time
        endDate.setHours(endDate.getHours() + (order.pickupTimeWindow || 0));
      } else {
        if (!order.deliveryEndDateTime) {
          return '';
        }
        endDate = new Date(order.deliveryEndDateTime);
        startDate = new Date(endDate);
        // Subtract time window hours to get start time
        startDate.setHours(startDate.getHours() - (order.deliveryTimeWindow || 0));
      }

      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');
      const startHours = String(startDate.getHours()).padStart(2, '0');
      const startMinutes = String(startDate.getMinutes()).padStart(2, '0');
      const endHours = String(endDate.getHours()).padStart(2, '0');
      const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
      
      // Format as "yyyy-MM-dd HH:mm-HH:mm"
      return `${year}-${month}-${day} ${startHours}:${startMinutes}-${endHours}:${endMinutes}`;
    } catch (e) {
      return '';
    }
  }
}

